module.exports = __webpack_public_path__ + "static/media/explosion.8fddd95f.mp3";